import { IExperience } from "../interfaces/IExperience";

export const data: IExperience[] = [
  {
    organization: "Bapco Energies",
    location: "Awali, Bahrain",
    totalDuration: "Jun 2025 – Present",
    roles: [
      {
        date: "Oct 2025 – Present",
        role: "Senior Specialist – Digital Workplace & Automation",
        description:
          "Work on automation and digital workplace transformation across the organization. Act as project manager on key delivery projects while designing and implementing solutions to improve operational efficiency.",
        technologies: ["React", "TypeScript", "Power Automate", "SharePoint", "Low Code"],
      },
      {
        date: "Jun 2025 – Dec 2025",
        role: "Analyst – Platform Development",
        description:
          "Developed and maintained internal platforms as part of the transition to Bapco Energies. Worked with cross-functional teams to deliver platform updates and new features.",
        technologies: ["React", "TypeScript", "Node.js", "SPFX"],
      },
    ],
  },
  {
    organization: "Bapco Refining",
    location: "Southern Governorate, Bahrain",
    totalDuration: "Dec 2021 – Jul 2025",
    roles: [
      {
        date: "Aug 2023 – Jul 2025",
        role: "Business Applications Developer Analyst",
        description:
          "Developed and maintained business applications used throughout Bapco Refining. Worked with cross-functional teams including developers, designers, and project managers.",
        technologies: ["React", "HTML & CSS", "TypeScript", "Node.js", "SPFX", "Low Code"],
      },
      {
        date: "Aug 2022 – Aug 2023",
        role: "Systems Analyst – Associate",
        description:
          "Analyzed and improved existing IT systems and workflows. Collaborated with stakeholders to gather requirements and translate them into technical specifications.",
        technologies: ["React", "HTML & CSS", "TypeScript", "SQL"],
      },
      {
        date: "Dec 2021 – Jul 2022",
        role: "IT Graduate Trainee",
        description:
          "Rotated through key IT departments to gain hands-on experience with enterprise systems, software development practices, and infrastructure management.",
        technologies: ["HTML & CSS", "JavaScript", "SQL"],
      },
    ],
  },
  {
    organization: "Bahrain Ministry of Interior",
    location: "Manama, Bahrain",
    totalDuration: "Sep 2019 – Dec 2019",
    roles: [
      {
        date: "Sep 2019 – Dec 2019",
        role: "Development Intern",
        description:
          "Developed a paperless ISO platform for the Ministry of Interior, encompassing both front-end and back-end solutions. Gathered requirements, designed database and workflow diagrams, created UI/UX mockups with Adobe XD, and built the application using N-Tier architecture.",
        technologies: ["ASP.NET", "C#", "HTML", "CSS", "SQL"],
      },
    ],
  },
];
